import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { InquiryService } from 'src/app/services/inquiry.service';
@Component({
  selector: 'app-mobile-filter',
  templateUrl: './mobile-filter.component.html',
  styleUrls: ['./mobile-filter.component.css']
})
export class MobileFilterComponent implements OnInit {
  @Output() isClose = new EventEmitter(); //退回
  @Output() isSave = new EventEmitter(); //保存
  submittedDateStart = null;
  submittedDateEnd = null;
  acceptDateStart = null;
  acceptDateEnd = null;
  closedDateStart = null;
  closedDateEnd = null;
  ticketStatusList: any[] = [];
  problemCategoryList: any[] = [];
  supportTeamList: any[] = [];
  lang = localStorage.getItem('lang') || 'en'
  isDescTicketNo = "";
  isDescAcceptedBy = "";
  isDescSubmittedBy = "";
  isDescClosedBy = "";
  isDescSubmittedDate = "";
  isDescAcceptedDate = "";
  isDescClosedDate = "";
  isSupport: boolean = false;
  acceptedBy:string = "";

  constructor(private inquiryService: InquiryService) { }
  async ngOnInit() {
    this.isSupport = localStorage.getItem("isSupport") == "true" ? true : false;
    this.inquiryService.getTicketStatus().subscribe(
      {
        next: (list) => {
          this.ticketStatusList  = list.data.map((ticketStatus: { ticketStatusDescr: any; id: any; }) => {
            return {
              label: this.isSupport && ticketStatus.id == 2 ? 'In Progress(Accepted)': (this.isSupport && ticketStatus.id == 4 ? 'In Progress(Reassigned)' : ticketStatus.ticketStatusDescr)  ,
              value: ticketStatus.id,
              checked: false
            }
          })
          if(this.isSupport) {
            this.ticketStatusList.splice(3,1,...this.ticketStatusList.splice(2, 1 , this.ticketStatusList[3]))
          }else{
            this.ticketStatusList.splice(-2,1);
          }
        },
        error: (error) => {
          console.error('error: ' + error);
        }
      }
    )
    this.inquiryService.getProblemCategory().subscribe(
      {
        next: (list) => {
          this.problemCategoryList = list.data.map((problemCategory: { categoryDescrEng: any; categoryDescrChi: any; id: any; }) => {
            return {
              label: this.lang == "en" ? problemCategory.categoryDescrEng : problemCategory.categoryDescrChi,
              value: problemCategory.id,
              checked: false
            }
          })
        },
        error: (error) => {
          console.error('error: ' + error);
        }
      }
    )
    this.inquiryService.getSupportTeam().subscribe(
      {
        next: (list) => {
          this.supportTeamList = list.data.map((team: { teamDescrEng: any; teamDescrChi: any; id: any; }) => {
            return {
              label: this.lang == "en" ? team.teamDescrEng : team.teamDescrChi,
              value: team.id,
              checked: false
            }
          })
        },
        error: (error) => {
          console.error('error: ' + error);
        }
      }
    )
  }
  back() {
    this.isClose.emit(false);
  }
  save() {
    this.isSave.emit();
  }
  radioSelect(type: string) {
    switch (type) {
      case 'ticketNo':
        this.isDescAcceptedBy = "";
        this.isDescSubmittedBy = "";
        this.isDescClosedBy = "";
        this.isDescSubmittedDate = "";
        this.isDescAcceptedDate = "";
        this.isDescClosedDate = "";
        break;
      case 'fullName':
        this.isDescTicketNo = "";
        this.isDescAcceptedBy = "";
        this.isDescClosedBy = "";
        this.isDescSubmittedDate = "";
        this.isDescAcceptedDate = "";
        this.isDescClosedDate = "";
        break;
      case 'acceptBy':
        this.isDescTicketNo = "";
        this.isDescSubmittedBy = "";
        this.isDescClosedBy = "";
        this.isDescSubmittedDate = "";
        this.isDescAcceptedDate = "";
        this.isDescClosedDate = "";
        break;
      case 'closedBy':
        this.isDescTicketNo = "";
        this.isDescAcceptedBy = "";
        this.isDescSubmittedBy = "";
        this.isDescSubmittedDate = "";
        this.isDescAcceptedDate = "";
        this.isDescClosedDate = "";
        break;
      case 'submittedDate':
          this.isDescTicketNo = "";
          this.isDescAcceptedBy = "";
          this.isDescSubmittedBy = "";
          this.isDescClosedBy = "";
          this.isDescAcceptedDate = "";
          this.isDescClosedDate = "";
          break;
      case 'acceptedDate':
          this.isDescTicketNo = "";
          this.isDescAcceptedBy = "";
          this.isDescSubmittedBy = "";
          this.isDescClosedBy = "";
          this.isDescSubmittedDate = "";
          this.isDescClosedDate = "";
            break;
      case 'closedDate':
          this.isDescTicketNo = "";
          this.isDescAcceptedBy = "";
          this.isDescSubmittedBy = "";
          this.isDescClosedBy = "";
          this.isDescAcceptedDate = "";
          this.isDescSubmittedDate = "";
          break;
      default:
        break;
    }
  }
}
